import styles from '@components/components/HeatInstallationForm/components/Detail/Detail.module.scss';
import ActionFooter from '@components/components/HeatInstallationForm/components/ActionFooter';
import { InputFieldNumeric } from '@components/components';
import React from 'react';
import {
  Card,
  CardBody,
  Container,
  Content,
  FontAwesomeProIcon,
  Heading,
  List,
  ListItem,
  Radio,
} from '@wienenergiegithub/ui-next';
import { FormLabel, FormRadio, FormRadioGroup } from '@ariakit/react';

const Detail = ({
  store,
  prev,
  step,
  isGeneralRecommender,
  handleSkipStep,
  setNextValidStep,
}) => (
  <Container size="lg">
    <Heading className={styles.semi} size="h2">
      {isGeneralRecommender
        ? 'Ihre Wärme Kostenkalkulation (2/4)'
        : 'Ihre Kostenkalkulation'}
    </Heading>
    <Content>
      Für eine erste Kostenkalkulation zur Nachinstallation von Fernwärme
      benötigen wir von Ihnen noch folgende Informationen:
    </Content>

    <Card className={styles.container}>
      <CardBody className={styles.cardBody}>
        <Heading className={styles.semi} size="h6">
          Wohnungsangaben
        </Heading>
        <InputFieldNumeric
          className={styles.field}
          label="Wie groß ist Ihre Wohnfläche in Quadratmeter?"
          name={store.names.size}
          placeholder="Fläche in m²"
          required
          store={store}
        />
        <InputFieldNumeric
          className={styles.field}
          label="Wieviele Heizkörper befinden sich in Ihrer Wohnung?"
          name={store.names.radiatorCount}
          required
          store={store}
        />
      </CardBody>
    </Card>
    <br />
    <Card className={styles.container}>
      <CardBody className={styles.cardBody}>
        <FormRadioGroup
          className={styles.field}
          name={store.names.isOwner}
          store={store}
        >
          <FormLabel
            className={styles.radioLabel}
            name={store.names.warmWaterDevice}
            render={<legend />}
            store={store}
          >
            Haben Sie Interesse an einem Warmwassergerät?
          </FormLabel>

          <div className={styles.radios}>
            <FormRadio
              data-purpose="warm-water-device-yes"
              label="Ja"
              name={store.names.warmWaterDevice}
              render={<Radio label="Ja" />}
              required
              store={store}
              value="Ja"
              variant="horizontal"
            />
            <FormRadio
              data-purpose="warm-water-device-no"
              label="Nein"
              name={store.names.warmWaterDevice}
              render={<Radio label="Nein" />}
              required
              store={store}
              value="Nein"
              variant="horizontal"
            />
          </div>
        </FormRadioGroup>
        <Heading className={styles.listHeading} size="h6">
          Welche Vorteile hat ein Warmwassergerät?
        </Heading>
        <List
          align="center"
          className={styles.list}
          icon={
            <FontAwesomeProIcon
              icon="check"
              role="presentation"
              type="regular"
            />
          }
          type="checkmark"
        >
          <ListItem>Warmwasser ist rund um die Uhr verfügbar</ListItem>
          <ListItem>Ökologisch Heizen ohne Gas</ListItem>
          <ListItem>Keine laufende Wartung erforderlich</ListItem>
        </List>
        {/* </Accordion> */}
      </CardBody>
    </Card>
    <ActionFooter
      handleSkipStep={handleSkipStep}
      isGeneralRecommender={isGeneralRecommender}
      nextText="Jetzt Berechnen"
      prev={prev}
      setNextValidStep={setNextValidStep}
      step={step}
      stepName="kostenkalkulation"
      store={store}
    />
  </Container>
);

export default Detail;
